<section class="error">
    <div class="error-content">
        <div class="left-roboto"><img src="/assets/images/invalidLink-error.png" alt="error-img" class="img-fluid"></div>
        <div class="middle-content">
            <h1>{{message}}</h1>
            <a class="btn" *ngIf="statusCode != 498" onClick="javascript:history.go(-1)">  <i class="fa fa-angle-left"></i>&nbsp;Back </a>
            <a class="btn" *ngIf="statusCode == 498" (click)="redirectToHomePage()" ><i class="fa fa-angle-left"></i>&nbsp;Back to Home</a> 
        </div>
        <div class="right-roboto">
            <img src="/assets/images/robot.png" alt="error-img" class="img-fluid robot">
            <img src="/assets/images/ballon.png" alt="error-img" class="img-fluid ballon">
            <img src="/assets/images/ballon-1.png" alt="error-img" class="img-fluid ballon-1">
        </div>
    </div>
    </section>


<!-- 
<div class="container">

    <section class="error">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12 order-2">
                    <div class="opps">
                        <h1>{{message}}</h1>
                        <div class="row">
                            <a class="link btnleft" *ngIf="statusCode != 498" onClick="javascript:history.go(-1)">  <i class="fa fa-angle-left"></i>&nbsp;Back </a>
                            <a class="link btnleft" *ngIf="statusCode == 498" (click)="redirectToHomePage()" ><i class="fa fa-angle-left"></i>&nbsp;Back to Home</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 order-1 order-lg-12">
                    <div class="error-img mx-auto">
                      <img src="/assets/images/invalidLink-error.png" alt="error-img" class="img-fluid imagecs"> 
                        <img src="/assets/images/robot.png" alt="error-img" class="img-fluid robot">
                        <img src="/assets/images/ballon.png" alt="error-img" class="img-fluid ballon">
                        <img src="/assets/images/ballon-1.png" alt="error-img" class="img-fluid ballon-1">
                    </div>

                </div>
            </div> 
        </div> 
    </section>
</div>-->
